/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BillingDocument } from '../../models/billing-document';
import { DismissBillingDocument } from '../../models/dismiss-billing-document';

export interface DismissBillingDocument$Params {
  id: number;
  
    /**
     * Optional comment about the dismissal
     */
    body?: DismissBillingDocument
}

export function dismissBillingDocument(http: HttpClient, rootUrl: string, params: DismissBillingDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<BillingDocument>> {
  const rb = new RequestBuilder(rootUrl, dismissBillingDocument.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BillingDocument>;
    })
  );
}

dismissBillingDocument.PATH = '/billing-document/{id}/dismiss';
